import { memo } from 'react';
import cx from 'classnames';

import { Button, Text } from 'components';

import styles from './Stepper.module.scss';

export type StepperProps = {
  activeStep?: number;
  stepsCount?: number;
};

const Stepper = ({ stepsCount = 0, activeStep }: StepperProps): JSX.Element => (
  <div className={styles.container}>
    <ul>
      {[...Array(stepsCount)]
        .map((_, index) => index + 1)
        .map(step => (
          <li key={step}>
            <Button
              className={cx(styles.step, {
                [styles.active]: step === activeStep
              })}
              circle="lg"
            >
              <Text size="h2">{step}</Text>
            </Button>
          </li>
        ))}
    </ul>
  </div>
);

export default memo(Stepper);
